//搬出管理
export default [{
  path: '/archivalInformation',
  component: () => import('../pages/busManage/archivalInformation.vue'),
  name: 'ArchivalInformation',
  title: "运营备案信息",
  meta: {
    title: "运营备案信息"
  }
},
  {
    path: '/lineManage',
    component: () => import('../pages/busManage/lineManage.vue'),
    name: 'LineManage',
    title: "运营路线管理",
    meta: {
      title: "运营路线管理"
    }
  }, {
    path: '/orderManagement',
    component: () => import('../pages/busManage/orderManagement.vue'),
    name: 'OrderManagement',
    title: "订单管理",
    meta: {
      title: "订单管理"
    }
  },
  {
    path: '/busoperationaldata',
    component: () => import('../pages/busManage/busoperationaldata.vue'),
    name: 'Busoperationaldata',
    title: "班车运营数据",
    meta: {
      title: "班车运营数据"
    }
  },
  {
    path: '/addArchivalInformation',
    component: () => import('../pages/busManage/addArchivalInformation.vue'),
    name: 'AddArchivalInformation',
    title: "编辑备案信息",
    meta: {
      title: "编辑备案信息"
    }
  },
];
